<h2 mat-dialog-title class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ isEditMode ? 'Edit Work Experience' : 'Add Work Experience' }}</h2>
<mat-dialog-content class="dialog-content">
  <form [formGroup]="form">
    <div class="job-position-row">
      <app-autocomplete-select
        #jobPositionAutocomplete
        [isFullWidth]="true"
        [searchFunction]="searchJobPositions"
        [maxResults]="1000"
        displayProperty="name"
        label="Find a job position"
        placeholder="Type at least 3 characters to search..."
        (optionSelected)="onJobPositionSelected($event)">
      </app-autocomplete-select>
      @if (canAddNewJobPosition) {
        <button
          mat-mini-fab
          color="primary"
          type="button"
          class="add-job-position-button"
          matTooltip="Add as a new job position"
          (click)="onAddNewJobPosition()">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
    <div class="job-position-row">
      <app-autocomplete-select
        #companyAutocomplete
        [isFullWidth]="true"
        [searchFunction]="searchCompanies"
        [maxResults]="1000"
        displayProperty="displayName"
        label="Find a company"
        placeholder="Type at least 3 characters to search..."
        (optionSelected)="onCompanySelected($event)">
      </app-autocomplete-select>
      @if (canAddNewWorkExperienceCompany) {
        <mat-form-field appearance="fill" class="new-company-country">
          <mat-label>Country</mat-label>
          <mat-select [formControl]="newCompanyCountryControl" [compareWith]="compareCountryById">
            @for (country of countries; track country.id) {
              <mat-option [value]="country">{{ country.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          mat-mini-fab
          color="primary"
          type="button"
          class="add-job-position-button"
          [disabled]="!newCompanyCountryControl.value"
          matTooltip="Add as a new company"
          (click)="onAddNewWorkExperienceCompany()">
          <mat-icon>add</mat-icon>
        </button>
      }
    </div>
    <div class="date-row">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
        <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <span class="present-slot" aria-hidden="true"></span>
    </div>
    <div class="date-row">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
        <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-checkbox class="present-slot" formControlName="isPresent">Present</mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!form.valid" (click)="onConfirm()">{{ isEditMode ? 'Save' : 'Add' }}</button>
</mat-dialog-actions>
